import { render, staticRenderFns } from "./atlas.vue?vue&type=template&id=467bfd23&scoped=true&"
import script from "./atlas.vue?vue&type=script&lang=js&"
export * from "./atlas.vue?vue&type=script&lang=js&"
import style0 from "./atlas.vue?vue&type=style&index=0&id=467bfd23&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467bfd23",
  null
  
)

export default component.exports